module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Frontend Mentor Countries RestAPI Challenge","short_name":"Countries RestAPI Challenge FM","description":"Displaying global countries & relevent information by integrating with the REST Countries API to pull country data","lang":"en","start_url":"/","icon":"src/images/globe.svg","theme_color_in_head":false,"display":"browser","legacy":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"8219c607bd3657b8200f72ef9bc89371"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
